module.exports = __webpack_public_path__ + "static/media/Covenants-Conditions-Restrictions-Trailwood.cfb77708.pdf";